import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "i-tabs" };
import ViewModeSwitchButton from "./ViewModeSwitchButton.vue";
import { ref, watch } from "vue";
import cookies from "js-cookie";
import EventBus from "../../../events/EventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ViewModeSwitch',
    setup(__props) {
        const mode = ref(cookies.get('grid-view-mode') === 'more' ? 'more' : 'less');
        const gridElement = document.querySelector('.catalog_items');
        watch(mode, value => {
            cookies.set('grid-view-mode', value, { path: '/', expires: 365 });
            if (value === 'more') {
                gridElement.classList.add('grid--more');
            }
            else {
                gridElement.classList.remove('grid--more');
            }
            EventBus.emit('products:view-mode-change');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                _createVNode(ViewModeSwitchButton, {
                    mode: "less",
                    modelValue: mode.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((mode).value = $event)),
                    onClick: _cache[1] || (_cache[1] = ($event) => (mode.value = 'less'))
                }, null, 8 /* PROPS */, ["modelValue"]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createVNode(ViewModeSwitchButton, {
                    mode: "more",
                    modelValue: mode.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((mode).value = $event)),
                    onClick: _cache[3] || (_cache[3] = ($event) => (mode.value = 'more'))
                }, null, 8 /* PROPS */, ["modelValue"])
            ]));
        };
    }
});
